module.exports = __webpack_public_path__ + "img/mainarticle3.10783ef7.png";